
import React from 'react';

const ContactMap = () => {
  return (
    <div className="bg-white rounded-lg border-2 border-primary/30 shadow-lg h-full">
      <iframe
        title="DIETRONIK Service Standort"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        src="https://www.google.com/maps/embed/v1/place?q=dietronik+service+wehingen&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
        className="w-full h-full rounded-lg"
      ></iframe>
    </div>
  );
};

export default ContactMap;
